import { useProgrammatic } from '@oruga-ui/oruga-next';

import BidDialogDisplay from "@/components/BidDialogDisplay.vue";

const {oruga} = useProgrammatic();
export const PRECON_BID_BANNER_DISMISSAL_KEY = 'precon-bid-banner-dismissed-at';
export const PRECON_BID_BANNER_DISMISSAL_DURATION = 7 * 24 * 60 * 60 * 1000;

export function dismissBidDialog(now = Date.now()) {
  localStorage.setItem(PRECON_BID_BANNER_DISMISSAL_KEY, now.toString());
}

export function shouldDisplayBidDialog(now = Date.now()) {
  const storedDismissedAt = localStorage.getItem(PRECON_BID_BANNER_DISMISSAL_KEY);

  if (!storedDismissedAt) {
    return true;
  }

  const dismissedAt = Number(storedDismissedAt);

  if (!Number.isFinite(dismissedAt) || dismissedAt <= 0) {
    localStorage.removeItem(PRECON_BID_BANNER_DISMISSAL_KEY);
    return true;
  }

  if (now - dismissedAt < PRECON_BID_BANNER_DISMISSAL_DURATION) {
    return false;
  }

  localStorage.removeItem(PRECON_BID_BANNER_DISMISSAL_KEY);

  return true;
}

export default function BidDialog() {
  if (!shouldDisplayBidDialog()) {
    return;
  }

  oruga.notification.open({
    component: BidDialogDisplay,
    indefinite: true,
    position: 'bottom-right',
    noticeClass: 'marketing-banner-notices',
    rootClass: 'marketing-banner-notification',
    variant: 'primary',
  });
};
